export class VoOffices {
  public static readonly VoForSkogsEkonomer = '452';
}
